import React, { useState, useEffect } from "react";
import { Typography, Button } from "@mui/material";

import { connect } from "react-redux";
import PropTypes from "prop-types";

import MacroCompoundRadialChart from "../../charts/MacroCompoundRadialChart";
import Spinner from "../../layout/Spinner";

//Modals
import CustomModal from "../../modal/CustomModal";
import TrackMacroEvent from "../modals/TrackMacroEvent";
import SingleMacroModal from "../modals/SingleMacroModal";

import MacroItem from "../components/MacroItem";

import { getMyMacros } from "../../../actions/insights";

//Icons
import { ReactComponent as StreakIcon } from "../../../assets/icons/svg/fire-flame.svg";
import { Link } from "react-router-dom";

//TODO: Make calories a bigger card at the top with circular chart, combine others into progress bars in one card for "other" macros
export const Nutrition = ({
  currentDate,
  setShowDateSelectModal,
  insights: { macrosData, macrosDataError, macrosDataLoading },
  getMyMacros,
}) => {
  const formatDate = (date) => {
    const day = date.getDate();
    const suffix = ["th", "st", "nd", "rd"][day % 10 > 3 ? 0 : (((day % 100) - (day % 10) !== 10) * day) % 10];
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric" }).replace(/\d+/, day + suffix);
  };

  const formatDay = (date) => {
    return date.toLocaleDateString("en-US", { weekday: "long" });
  };

  //Modal
  const [showTrackMacroEventModal, setShowTrackMacroEventModal] = useState(false);
  const [showAllMacros, setShowAllMacros] = useState(false);
  const [showCaloriesModal, setShowCaloriesModal] = useState(false);

  const handleTrackMacroEventModalClose = () => {
    setShowTrackMacroEventModal(false);
  };

  const fetchMyMacros = async (date) => {
    await getMyMacros(date);
  };

  useEffect(() => {
    const today = currentDate.toISOString().split("T")[0];
    fetchMyMacros(today);
  }, [currentDate]);

  return (
    <div className="flex flex-col md:gap-2">
      <div className="p-4 border border-separator md:rounded-md shadow-sm bg-background">
        <CustomModal open={showTrackMacroEventModal} handleClose={handleTrackMacroEventModalClose} type="bottom">
          <TrackMacroEvent />
        </CustomModal>

        <div className="flex flex-row justify-between items-center">
          <Typography variant="h6" className="leading-none font-normal">
            Nutrition
          </Typography>
          {false && (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              disableElevation
              className="text-primaryText"
              onClick={() => setShowTrackMacroEventModal(true)}
            >
              + Track
            </Button>
          )}
          <Link to="/cookbook">
            <Button variant="contained" color="secondary" size="small" disableElevation className="text-primaryText">
              + Cook Now
            </Button>
          </Link>
        </div>
      </div>
      <div className="w-full h-full flex flex-col md:flex-row justify-between items-center md:gap-16 p-4 md:px-8 md:border border-separator md:rounded-md shadow-sm bg-background">
        {macrosDataLoading ? (
          <div className="w-full h-full flex items-center justify-center min-h-[65vh]">
            <Spinner />
          </div>
        ) : macrosDataError ? (
          <div className="w-full h-full flex items-center justify-center">
            <Typography variant="subtitle1">
              Error fetching your meal history.<br></br>Please refresh the page and try again.
            </Typography>
          </div>
        ) : (
          <>
            <CustomModal
              open={showCaloriesModal}
              handleClose={() => setShowCaloriesModal(false)}
              type="bottomToCentered"
            >
              <SingleMacroModal macro={macrosData.macros[0].macro} date={currentDate} />
            </CustomModal>
            <div className="flex flex-row gap-2 w-full px-4 md:px-0 md:w-1/2">
              <Button
                className="p-0 hover:bg-transparent flex flex-col items-start text-start w-full h-full cursor-pointer"
                onClick={() => setShowCaloriesModal(true)}
                disableRipple
              >
                <div className="w-full h-full flex-1 cursor-pointer">
                  <MacroCompoundRadialChart
                    macroData={macrosData.macros[0]}
                    showMacroName={false}
                    className="cursor-pointer"
                  />
                </div>
              </Button>
            </div>
            <div className="w-full md:w-1/2">
              <div className="w-full flex flex-col items-center">
                <div className="w-full">
                  <Button
                    className="p-0 hover:bg-transparent flex flex-col items-start text-start"
                    onClick={() => setShowDateSelectModal(true)}
                    disableRipple
                  >
                    <Typography variant="subtitle1" className="text-secondaryText leading-none">
                      {formatDay(currentDate)}
                    </Typography>
                    <Typography variant="h5">{formatDate(currentDate)}</Typography>
                  </Button>
                </div>

                <div className="w-full my-2 flex flex-col gap-2">
                  <Typography variant="subtitle2" className="leading-none font-normal text-secondaryText-700">
                    {macrosData?.events?.length ? macrosData.events.length : 0} Nutrition Event
                    {macrosData?.events?.length === 1 ? "" : "s"}
                  </Typography>
                  <div className="flex flex-col gap-1 mt-2">
                    <Typography variant="body2" className="leading-none font-normal text-secondaryText-600">
                      Daily streak:
                    </Typography>
                    <div className="flex flex-row gap-2 items-center w-fit mt-1">
                      <StreakIcon className="h-6 w-auto fill-complementaryRed" />
                      <Typography
                        variant="subtitle2"
                        className="text-secondaryText-600 leading-none text-sm font-medium"
                      >
                        <span className=" font-semibold text-secondaryText-700 text-lg">
                          {macrosData?.streak ? macrosData.streak : 0}
                        </span>
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {!macrosDataLoading && !macrosDataError && macrosData?.macros?.length > 1 && (
        <div className="flex flex-col gap-2">
          <div className="grid border-b border-separator md:border-none md:gap-2 grid-cols-1 md:grid-cols-2">
            {macrosData?.macros?.slice(1, macrosData?.macros?.length).map((macro, i) => (
              <MacroItem key={`${macro._id}-${i}`} macroData={macro} date={currentDate} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  insights: state.insights,
});

export default connect(mapStateToProps, { getMyMacros })(Nutrition);
